import { render, staticRenderFns } from "./menu-item.vue?vue&type=template&id=2a5dbfea&"
import script from "./menu-item.vue?vue&type=script&lang=js&"
export * from "./menu-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a5dbfea')) {
      api.createRecord('2a5dbfea', component.options)
    } else {
      api.reload('2a5dbfea', component.options)
    }
    module.hot.accept("./menu-item.vue?vue&type=template&id=2a5dbfea&", function () {
      api.rerender('2a5dbfea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/menu/src/menu-item.vue"
export default component.exports